import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Import translation files
import enCommon from "@/locales/en/common.json";
import zhCommon from "@/locales/zh/common.json";
import viCommon from "@/locales/vi/common.json";
import thCommon from "@/locales/th/common.json";
import esCommon from "@/locales/es/common.json";

const resources = {
  en: {
    common: enCommon,
  },
  zh: {
    common: zhCommon,
  },
  vi: {
    common: viCommon,
  },
  th: {
    common: thCommon,
  },
  es: {
    common: esCommon,
  },
};

// Get saved language from localStorage or default to 'en'
const savedLanguage = localStorage.getItem("i18nextLng") ?? "en";

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: savedLanguage, // language to use
    fallbackLng: "en", // fallback language
    debug: process.env.NODE_ENV === "development",

    interpolation: {
      escapeValue: false, // react already does escaping
    },

    // Default namespace
    defaultNS: "common",

    // Key separator
    keySeparator: ".",

    // Save language to localStorage
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "i18nextLng",
      caches: ["localStorage"],
    },
  });

export default i18n;
